// utils/agora-utils.js - Compatible with your existing setup
// import AgoraRTC from 'agora-rtc-sdk-ng';con
// import AgoraRTM,{ RTM } from 'agora-rtm-sdk';
// import { useUserDetailContext } from '../Components/UserDetailContext';


const APP_ID = '1fef7950c055487fb4b134b1c8fb2fb6';

// RTM Client Management (optional, with fallback)
let rtmClient = null;
let currentUserId = null;
let rtmInitialized = false;

const apiKey = process.env.REACT_APP_API_KEY; // actual API key
const objectId = localStorage.getItem("objectId");


const headers = {
    'x-api-key': apiKey,
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${objectId}`
};

// ======================
// RTC Functions (Your Working Code)
// ======================

export const getDevices = async () => {
    return;
};

export const createClient = () => {
    // return AgoraRTC.createClient({ mode: 'rtc', codec: 'vp8' });
    return;
};

export const createMicrophoneTrack = async () => {
    // return await AgoraRTC.createMicrophoneAudioTrack();
    return;
};

export const createCameraTrack = async (deviceId = '') => {
    const config = {};
    if (deviceId) {
        config.cameraId = deviceId;
    }
    // return await AgoraRTC.createCameraVideoTrack(config);
    return;
};

// export const joinChannel = async (client, channelName, token, uid) => {
//   if (!client || !channelName || !token || !uid) {
//     console.error("Missing required parameters:", { channelName, token, uid });
//     throw new Error("Missing required parameters for joining channel");
//   }

//   try {
//     console.log("Joining channel with params:", {
//       channelName,
//       token,
//       uid
//     });

//     await client.join(
//       APP_ID,        // Your Agora App ID
//       channelName,   // Meeting name
//       token,         // RTC token
//       uid            // User ID
//     );

//     console.log("Successfully joined channel:", channelName);
//     return true;
//   } catch (error) {
//     console.error("Failed to join channel:", error);
//     throw error;
//   }
// };

export const joinChannel = async (client, channelName, token, currentUserId) => {
    console.log("client+++NNN", client, channelName, token, currentUserId)
    if (!client || !channelName || !token || !currentUserId) {
        console.error("Missing required parameters", { channelName, token, currentUserId });
        throw new Error("Missing required parameters for joining channel");
    }

    try {
        console.log("Joining channel with params:", {
            appId: APP_ID,
            channelName,
            token: token,
            currentUserId
        });

        // CRITICAL FIX: Pass APPID as first parameter
        await client.join(APP_ID, channelName, token, currentUserId);

        console.log("Successfully joined channel:", channelName);
        return true;
    } catch (error) {
        console.error("Failed to join channel:", error);
        console.error("Error details:", {
            code: error.code,
            message: error.message,
            stack: error.stack
        });
        throw error;
    }
};

export const publishTracks = async (client, tracks) => {
    try {
        console.log('📡 Publishing tracks:', tracks.length);
        await client.publish(tracks);
        console.log('✅ Tracks published successfully');
    } catch (error) {
        console.error('❌ Publish tracks failed:', error);
        throw error;
    }
};

export const leaveChannel = async (client) => {
    try {
        console.log('👋 Leaving channel');
        await client.leave();
        console.log('✅ Successfully left channel');
    } catch (error) {
        console.error('❌ Leave channel failed:', error);
        throw error;
    }
};

export const createScreenVideoTrack = async (config = {}, audio = 'disable') => {
    try {
        console.log('🖥️ Creating screen video track');
        // const track = await AgoraRTC.createScreenVideoTrack(config, audio);
        console.log('✅ Screen video track created');
        return;
    } catch (error) {
        console.error('❌ Failed to create screen track:', error);
        throw error;
    }
};

export const unpublishTracks = async (client, tracks) => {
    try {
        console.log('📡 Unpublishing tracks:', tracks.length);
        for (const track of tracks) {
            await client.unpublish(track);
        }
        console.log('✅ Tracks unpublished successfully');
    } catch (error) {
        console.error('❌ Failed to unpublish tracks:', error);
        throw error;
    }
};



// Enhanced token fetching
export const fetchRTCToken = async (channelName, uid) => {
    const tokenServerUrl = process.env.REACT_APP_BACKEND_URL;

    if (!tokenServerUrl) {
        throw new Error('Token server URL is not configured');
    }

    try {
        console.log(`🔑 Fetching RTC token for channel: ${channelName}, UID: ${uid}`);
        const response = await fetch(`${tokenServerUrl}/agora/generate-token/rtc/${channelName}/publisher/${uid}`, {
            method: 'GET',
            headers: headers
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('✅ RTC token fetched successfully');
        return data;
    } catch (error) {
        console.error('❌ Error fetching RTC token:', error);
        throw error;
    }
};

export const setupTokenRenewal = (client, channelName, uid) => {
    const handleTokenWillExpire = async () => {
        try {
            console.log('🔄 Renewing RTC token');
            const newToken = await fetchRTCToken(channelName, uid);
            await client.renewToken(newToken);
            console.log('✅ Token renewed successfully');
        } catch (error) {
            console.error('❌ Failed to renew token:', error);
        }
    };

    client.on('token-privilege-will-expire', handleTokenWillExpire);
    return () => {
        client.off('token-privilege-will-expire', handleTokenWillExpire);
    };
};

export const generateUID = (userId) => {
    console.log('🎯 Generating UID for user:', userId);

    if (userId) {
        const userIdStr = String(userId);
        const numericPart = userIdStr.replace(/[^0-9]/g, '');

        if (numericPart) {
            const uid = Math.abs(Number(numericPart)) % 999999;
            const finalUid = uid === 0 ? 1 : uid;
            console.log(`✅ Generated UID: ${finalUid} from numeric part: ${numericPart}`);
            return finalUid;
        }

        let hash = 0;
        for (let i = 0; i < userIdStr.length; i++) {
            const char = userIdStr.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash;
        }

        const uid = Math.abs(hash) % 999999;
        const finalUid = uid === 0 ? 1 : uid;
        console.log(`✅ Generated UID: ${finalUid} from string hash`);
        return finalUid;
    }

    const randomUid = Math.floor(Math.random() * 999999) + 1;
    console.log(`✅ Generated random UID: ${randomUid}`);
    return randomUid;
};

// export const generateUID = (userId) => {
//   console.log('🎯 Generating UID for user:', userId);

//   if (userId) {
//     // Ensure consistent UID generation for the same user
//     const userIdStr = String(userId);
//     let hash = 0;

//     for (let i = 0; i < userIdStr.length; i++) {
//       const char = userIdStr.charCodeAt(i);
//       hash = ((hash << 5) - hash) + char;
//       hash = hash & hash; // Convert to 32-bit integer
//     }

//     const uid = Math.abs(hash) % 1000000; // Ensure it's within Agora's limits
//     const finalUid = uid === 0 ? 1 : uid;
//     console.log(`✅ Generated consistent UID: ${finalUid} for user: ${userId}`);
//     return finalUid;
//   }

//   const randomUid = Math.floor(Math.random() * 1000000) + 1;
//   console.log(`✅ Generated random UID: ${randomUid}`);
//   return randomUid;
// };

// ======================
// RTM Functions (Optional with Fallback)
// ======================

// Try to initialize RTM (non-blocking)
export const initializeRTM = async (userId, token) => {
    try {
        if (rtmClient) {
            await rtmClient.logout();
            rtmClient = null;
        }

        currentUserId = userId;
        console.log('🔄 Attempting RTM initialization for user:', userId);

        // Create RTM client instance
        // rtmClient = new RTM(APP_ID, String(userId), {
        //     token: token,
        //     encryptionMode: 'none',
        //     cloudProxy: false,
        //     logUpload: false,
        //     logLevel: 'info'
        // });

        // Set up event listeners
        setupRTMEventListeners();

        // Login to RTM
        await rtmClient.login();

        // Subscribe to user's private inbox for incoming calls
        const inboxChannel = `inbox_${userId}`;
        await rtmClient.subscribe(inboxChannel, {
            withMessage: true,
            withPresence: false,
            withMetadata: false,
            withLock: false
        });

        rtmInitialized = true;
        console.log('✅ RTM initialized successfully for user:', userId);
        return rtmClient;
    } catch (error) {
        console.warn('⚠️ RTM initialization failed, will use fallback method:', error);
        rtmInitialized = false;
        // Don't throw error, just log warning and continue
        return null;
    }
};

// Set up RTM event listeners
const setupRTMEventListeners = () => {
    if (!rtmClient) return;

    rtmClient.addEventListener('message', (event) => {
        handleIncomingRTMMessage(event);
    });

    rtmClient.addEventListener('linkStateEvent', (event) => {
        console.log('🔗 RTM connection state changed:', event);
    });

    rtmClient.addEventListener('tokenPrivilegeWillExpire', async () => {
        try {
            console.log('🔄 RTM token expiring, renewing...');
            const newToken = await fetchRTMToken(currentUserId);
            await rtmClient.renewToken(newToken);
            console.log('✅ RTM token renewed');
        } catch (error) {
            console.error('❌ Failed to renew RTM token:', error);
        }
    });
};

// Handle incoming RTM messages
const handleIncomingRTMMessage = (event) => {
    try {
        console.log('📨 Incoming RTM message:', event);

        let messageData;
        try {
            messageData = typeof event.message === 'string'
                ? JSON.parse(event.message)
                : event.message;
        } catch {
            return;
        }

        if (messageData.type === 'call-invitation') {
            console.log('📞 Received call invitation via RTM:', messageData);

            const callEvent = new CustomEvent('incoming-call', {
                detail: messageData
            });
            window.dispatchEvent(callEvent);
        } else if (messageData.type === 'call-response') {
            console.log('📲 Received call response via RTM:', messageData);

            const responseEvent = new CustomEvent('call-response', {
                detail: messageData
            });
            window.dispatchEvent(responseEvent);
        } else if (messageData.type === 'call-cancel') {
            console.log('🚫 Call was cancelled via RTM:', messageData);

            const cancelEvent = new CustomEvent('call-cancelled', {
                detail: messageData
            });
            window.dispatchEvent(cancelEvent);
        }
    } catch (error) {
        console.error('❌ Error handling RTM message:', error);
    }
};

// Send call invitation (with fallback to custom events)
// export const sendCallInvitation = async (callData) => {
//   const { 
//     callId, 
//     meetingName, 
//     rtcToken, 
//     callerUid, 
//     caller, 
//     participants 
//   } = callData;

//   try {
//     // Try RTM first if available
//     if (rtmClient && rtmInitialized) {
//       console.log('📤 Sending call invitations via RTM to:', participants);

//       const invitationMessage = {
//         type: 'call-invitation',
//         callId: callId || generateCallId(),
//         meetingName,
//         rtcToken,
//         uid: callerUid,
//         callerUid,
//         caller,
//         timestamp: Date.now()
//       };

//       const sendPromises = participants.map(async (participantId) => {
//         const inboxChannel = `inbox_${participantId}`;
//         const personalizedMessage = {
//           ...invitationMessage,
//           to: participantId
//         };

//         await rtmClient.publish(inboxChannel, JSON.stringify(personalizedMessage), {
//           customType: 'call-invitation'
//         });

//         console.log(`✅ RTM invitation sent to ${participantId}`);
//       });

//       await Promise.all(sendPromises);
//       console.log('✅ All RTM call invitations sent successfully');
//       return true;
//     } else {
//       throw new Error('RTM not available');
//     }
//   } catch (error) {
//     console.warn('⚠️ RTM failed, using fallback custom events:', error);

//     // Fallback to custom events (for local testing)
//     participants.forEach((participantId) => {
//       const event = new CustomEvent("incoming-call", {
//         detail: {
//           caller,
//           meetingName,
//           rtcToken,
//           uid: callerUid,
//           to: participantId,
//           callId: callId || generateCallId(),
//           timestamp: Date.now()
//         },
//       });
//       window.dispatchEvent(event);
//       console.log(`✅ Fallback invitation sent to ${participantId}`);
//     });

//     return true;
//   }
// };
export const sendCallInvitation = async (targetUserId, callData) => {
    try {
        const message = {
            type: 'call-invitation',
            meetingName: callData.meetingName,
            rtcToken: callData.rtcToken,
            caller: callData.caller,
            uid: callData.uid,
            timestamp: Date.now()
        };



        await rtmClient.sendMessageToPeer(
            { text: JSON.stringify(message) },
            targetUserId.toString()
        );

        return true;
    } catch (error) {
        console.error("Failed to send call invitation:", error);
        return false;
    }
};


// Generate unique call ID
export const generateCallId = () => {
    return `call_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};

// Fetch RTM Token (optional)
export const fetchRTMToken = async (userId) => {
    const tokenServerUrl = process.env.REACT_APP_BACKEND_URL;

    if (!tokenServerUrl) {
        throw new Error('Token server URL not configured');
    }

    try {
        console.log(`🔑 Fetching RTM token for user: ${userId}`);
        const response = await fetch(`${tokenServerUrl}/agora/generate-token/rtm/${userId}`, {
            method: 'GET',
            headers: headers
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('✅ RTM token fetched successfully');
        return data.rtmToken;
    } catch (error) {
        console.error('❌ Error fetching RTM token:', error);
        throw error;
    }
};

// Accept call invitation
export const acceptCallInvitation = async (callData) => {
    if (!rtmClient || !rtmInitialized) {
        console.warn('⚠️ RTM not available for sending accept response');
        return true;
    }

    const { caller, callId } = callData;

    try {
        const response = {
            type: 'call-response',
            callId,
            response: 'accepted',
            from: currentUserId,
            timestamp: Date.now()
        };

        const callerId = caller?.contactrefid || caller?.contact_ref_id || caller?.id;
        const callerInbox = `inbox_${callerId}`;

        await rtmClient.publish(callerInbox, JSON.stringify(response), {
            customType: 'call-response'
        });

        console.log('✅ Call acceptance sent via RTM to caller');
        return true;
    } catch (error) {
        console.error('❌ Failed to send call acceptance via RTM:', error);
        return true; // Don't fail the call acceptance
    }
};

// Decline call invitation
export const declineCallInvitation = async (callData) => {
    if (!rtmClient || !rtmInitialized) {
        console.warn('⚠️ RTM not available for sending decline response');
        return true;
    }

    const { caller, callId } = callData;

    try {
        const response = {
            type: 'call-response',
            callId,
            response: 'declined',
            from: currentUserId,
            timestamp: Date.now()
        };

        const callerId = caller?.contactrefid || caller?.contact_ref_id || caller?.id;
        const callerInbox = `inbox_${callerId}`;

        await rtmClient.publish(callerInbox, JSON.stringify(response), {
            customType: 'call-response'
        });

        console.log('✅ Call decline sent via RTM to caller');
        return true;
    } catch (error) {
        console.error('❌ Failed to send call decline via RTM:', error);
        return true; // Don't fail the call decline
    }
};

// Cancel call invitation
export const cancelCallInvitation = async (callId, participants) => {
    if (!rtmClient || !rtmInitialized) {
        console.warn('⚠️ RTM not available for sending cancel');
        return true;
    }

    try {
        const cancelMessage = {
            type: 'call-cancel',
            callId,
            from: currentUserId,
            timestamp: Date.now()
        };

        const cancelPromises = participants.map(async (participantId) => {
            const inboxChannel = `inbox_${participantId}`;
            await rtmClient.publish(inboxChannel, JSON.stringify(cancelMessage), {
                customType: 'call-cancel'
            });
        });

        await Promise.all(cancelPromises);
        console.log('✅ Call cancellation sent via RTM to all participants');
        return true;
    } catch (error) {
        console.error('❌ Failed to cancel call via RTM:', error);
        return true;
    }
};

// Cleanup RTM resources
export const cleanupRTM = async () => {
    try {
        if (rtmClient) {
            await rtmClient.logout();
            rtmClient = null;
            currentUserId = null;
            rtmInitialized = false;
            console.log('✅ RTM cleanup completed');
        }
    } catch (error) {
        console.error('❌ Error during RTM cleanup:', error);
    }
};

// Check RTM status
export const isRTMInitialized = () => {
    return rtmInitialized;
};

// Legacy RTM functions (for backward compatibility)
export const loginRTM = async (client, uid) => {
    await client.login({ uid: String(uid) });
};

export const joinRTMChannel = async (client, channelName) => {
    const channel = client.createChannel(channelName);
    await channel.join();
    return channel;
};

export const leaveRTMChannel = async (channel) => {
    await channel.leave();
};

export const logoutRTM = async (client) => {
    await client.logout();
};

// Make sendCallInvitation available globally for fallback
if (typeof window !== 'undefined') {
    window.sendCallInvitation = sendCallInvitation;
}

// export const sendRTMCallInvitation = async (participants, callData) => {

//   try {
//     // if (!rtmClient || !rtmInitialized) {
//     //   console.warn('RTM not available, using fallback');
//     //   return false;
//     // }

//     const localInvitation = rtmClient.createLocalInvitation("receiverUserId");

//   console.log("HELLOMEEE", localInvitation)
//   localInvitation.content = JSON.stringify({
//   meetingName: "Team Sync",
//   channel: "testChannel123",
//   rtcToken: "xxxx",
//   caller: "Neel",
// });


//     const invitationMessage = {
//       type: 'call-invitation',
//       caller: callData.caller,
//       meetingName: callData.meetingName,
//       rtcToken: callData.rtcToken,
//       uid: callData.uid,
//       timestamp: Date.now()
//     };

//     // Send to each participant
//     const sendPromises = participants.map(async (participantId) => {
//       try {
//         const res = await rtmClient.sendMessageToPeer(
//           { text: JSON.stringify(invitationMessage) },
//           String(participantId)
//         );
//         console.log(`RTM invitation sent to ${participantId}`);
//         return true;
//       } catch (error) {
//         console.error(`Failed to send RTM invitation to ${participantId}:`, error);
//         return false;
//       }
//     });

//     const results = await Promise.allSettled(sendPromises);
//     const successCount = results.filter(r => r.status === 'fulfilled' && r.value).length;

//     return successCount > 0;
//   } catch (error) {
//     console.error('Failed to send RTM invitations:', error);
//     return false;
//   }
// }

// In agora-utils.js - Fix the sendRTMCallInvitation function
export const sendRTMCallInvitation = async (participants, callData) => {
    try {
        console.log("📤 Sending RTM invitations to:", participants);
        console.log("📤 Call data:", callData);

        if (!rtmClient) {
            console.warn("❌ RTM client not available, using fallback");
            return false;
        }

        const invitationMessage = {
            type: 'call-invitation',
            caller: callData.caller,
            meetingName: callData.meetingName,
            rtcToken: callData.rtcToken,
            uid: callData.uid,
            timestamp: Date.now(),
            callId: `call_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
        };

        // Send to each participant
        const sendPromises = participants.map(async (participantId) => {
            try {
                await rtmClient.sendMessageToPeer(
                    { text: JSON.stringify(invitationMessage) },
                    participantId.toString()
                );
                console.log(`✅ RTM invitation sent to ${participantId}`);
                return true;
            } catch (error) {
                console.error(`❌ Failed to send RTM invitation to ${participantId}:`, error);
                return false;
            }
        });

        const results = await Promise.allSettled(sendPromises);
        const successCount = results.filter(r => r.status === 'fulfilled' && r.value).length;

        console.log(`📊 RTM invitations sent: ${successCount}/${participants.length} successful`);
        return successCount > 0;
    } catch (error) {
        console.error('❌ Failed to send RTM invitations:', error);
        return false;
    }
}

export const getRTMClient = () => {
    return rtmClient;
};


export { rtmClient };


// In agora-utils.js - ensure this function works
export const fetchRTMToken1 = async (userId) => {
    const tokenServerUrl = process.env.REACT_APP_BACKEND_URL;

    if (!tokenServerUrl) {
        throw new Error('Token server URL not configured');
    }

    try {
        console.log(`🔑 Fetching RTM token for user: ${userId}`);
        const response = await fetch(`${tokenServerUrl}/agora/generate-token/rtm/${userId}`, {
            method: 'GET',
            headers: headers
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('✅ RTM token fetched successfully');
        return data.rtmToken || data.token;
    } catch (error) {
        console.error('❌ Error fetching RTM token:', error);
        throw error;
    }
};